import { Injectable } from '@angular/core';

import { UserApiService } from 'src/app/api/services/user-api.service';
import { UserStateService } from 'src/app/auth/services/user-state.service';
import { TrackerService } from 'src/app/components/logging/tracker.service';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(
    private trackerService: TrackerService,
    private userStateService: UserStateService,
    private userApiService: UserApiService,
  ) {}

  updateUser(username, profile) {
    return this.userApiService
      .update(username, profile, this.userStateService.isUserAdmin())
      .then((resp) => {
        this.userStateService.updateUserProfile(resp.item);

        this.trackerService.userEvent(
          'User Updated',
          this.userStateService.getUsername(),
          this.userStateService.checkUsername(username),
          {
            updatedUserId: username,
            updatedUserCompanyRole: profile.companyRole
              ? profile.companyRole
              : '',
          },
        );

        console.debug('User Profile updated');

        return resp;
      });
  }
}
